import styled from 'styled-components';
import LSTVLink from '~/components/LSTVLink';
import theme from '~/styles/styledComponentsTheme';

const Figure = styled.figure`
  margin: 24px 0;
  font-size: 18px;

  figcaption,
  a,
  span {
    font-size: inherit;
  }

  .image-container {
    border-radius: 5px 5px 5px 5px;
    max-width: 900px;
    overflow: hidden;
  }

  img {
    display: block;
    width: 100%;
  }

  figcaption {
    margin-top: 6px;
    line-height: 1.25rem;
    width: 100%;
    max-width: 900px;

    text-align: left;
  }
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const ImageContainer = ({ image_cta, children }: { image_cta?: string; children: React.ReactNode }) =>
  image_cta ? (
    <LSTVLink to={image_cta} className="image-container">
      {children}
    </LSTVLink>
  ) : (
    <div className="image-container">{children}</div>
  );

const Credit = styled.span`
  color: ${theme.coldGrey};
`;

const OptionalLink = ({ caption, to, credit }: { caption?: string; to?: string; credit?: boolean }) => {
  const displayedCaption = caption ?? to;
  if (!displayedCaption) {
    return null;
  }
  const content = to ? <LSTVLink {...{ to }}>{displayedCaption}</LSTVLink> : displayedCaption;
  return credit ? <Credit>Photo Credit: {content}</Credit> : <>{content}</>;
};

const Photo = ({
  src,
  alt,
  description,
  description_link,
  credit,
  credit_link,
  image_cta,
}: {
  src: string;
  alt?: string;
  description?: string;
  description_link?: string;
  credit?: string;
  credit_link?: string;
  image_cta?: string;
}) => (
  <Figure>
    <Wrapper>
      <ImageContainer {...{ image_cta }}>
        <img {...{ src, alt }} />
      </ImageContainer>
      <figcaption>
        <OptionalLink caption={description} to={description_link} />
        {(description || description_link) && (credit || credit_link) && ' '}
        <OptionalLink caption={credit} to={credit_link} credit />
      </figcaption>
    </Wrapper>
  </Figure>
);

export default Photo;
